export default {
  isLoggedInWithFirebaseAuth: false,
  // firebaseのuid
  uid: undefined,
  missions: [],
  checkinList: [],
  imageReputationList: [],
  modal: "",
  // Home, RouteSearch, JyutaiSearch, Notify, MyPage
  currentPageName: "JyutaiSearch",
  // search -> select -> result
  searchState: {
    dropspot: "search",
    mypage: "view", // view  or result
    jyutai: "search",
  },
  tabs: {
    dropspot: 0,
  },
  registrationId: undefined,
  registrationData: undefined,
  answers: undefined,
  loading: true,
  search: {
    dropspot: undefined,
    mypage: undefined,
    jyutai: undefined,
  },
  currentLat: undefined,
  currentLng: undefined,
  DepLatLng: {
    dropspot: undefined,
    mypage: undefined,
    jyutai: undefined,
  },
  DesLatLng: {
    dropspot: undefined,
    mypage: undefined,
    jyutai: undefined,
  },
  originalApiData: {
    dropspot: [],
    jyutai: [],
  },
  selectedFilter: {
    dropspot: {
      tag: [],
      distance: 6000,
    },
    jyutai: {
      tag: [],
      distance: 6000,
    },
  },
  selectedSpotData: {
    dropspot: undefined,
    // dropspot: {
    //   id: 3,
    //   name: "萌木の村 ROCK",
    //   category: {
    //     id: 3,
    //     name: "食事",
    //     active: true,
    //     created_at: "2022-07-27T12:06:43.763159+09:00",
    //     updated_at: "2022-07-27T12:06:43.763188+09:00",
    //   },
    //   business_hours:
    //     "月曜日: 11時00分～20時30分,火曜日: 11時00分～20時30分,水曜日: 11時00分～20時30分,木曜日: 11時00分～20時30分,金曜日: 11時00分～20時30分,土曜日: 11時00分～20時30分,日曜日: 11時00分～20時30分",
    //   tel: "0551-48-2521",
    //   reputation: 0,
    //   address: "日本、〒407-0301 山梨県北杜市高根町清里３５４５ 萌木の村内",
    //   lat: 35.9156759,
    //   lon: 138.4428641,
    //   comment:
    //     "カントリー喫茶店だった初代ロックが生まれたのは1971年。オープンアメリカンスタイルだった2代目を経て、今のロックは3代目です。ちょっとだけ生まれ変わっております。",
    //   home_page_url: "https://www.yamanashi-kankou.jp/kankou/eat/p3_0099.html",
    //   service_place_id: "ChIJP6ZpjfYUHGAR514MhHYGMos",
    //   reports: [],
    //   tag_spots: [
    //     { id: 1, tag: { id: 1, name: "子供連れにおすすめ" } },
    //     { id: 2, tag: { id: 2, name: "お一人様におすすめ" } },
    //     { id: 3, tag: { id: 3, name: "男性におすすめ" } },
    //     { id: 4, tag: { id: 4, name: "女性におすすめ" } },
    //     { id: 5, tag: { id: 5, name: "若者向け" } },
    //     { id: 6, tag: { id: 6, name: "シニア向け" } },
    //   ],
    //   spot_images: [
    //     {
    //       id: 2,
    //       image_url:
    //         "https://storage.googleapis.com/suisuitabi-server-flutter-dev-static/spot_images/%E5%AE%9D%E5%A1%9A%E3%81%AB%E3%81%84%E3%82%8B%E3%81%A8%E3%81%8D_604.jpg?X-Goog-Algorithm=GOOG4-RSA-SHA256&X-Goog-Credential=30721330066-compute%40developer.gserviceaccount.com%2F20230807%2Fauto%2Fstorage%2Fgoog4_request&X-Goog-Date=20230807T014150Z&X-Goog-Expires=86400&X-Goog-SignedHeaders=host&X-Goog-Signature=926bcb3e28787cbba998cfca7ceec87f391014c72fe87de94376d87789cbcd2254b1941a2321234ab031c0ad7fc724016c485857494088d1d46d1aa3c8fae16b9e72622f50943313ba6e26e14a410ffca6d88b8c236ac08967bc68b8cdb6c4904bdb16878ae0e1f418aa10cc768450ea1e9f39a78d535dafdb43955dc70761cf19553b043c6ddc073640a91b8d9a1752a1be54d26292018c81d72582a6ff1c662acb2a8f6203d7fa4ccce4e4fb04a409ca88efd750227bb93223df9c1bad96849f56d482637dfb21b8c18ebf97e7170686d9fc1b5374b8189667af293fafdc34f2778e947da28d28aa7957e4980207af5324fd6f538abb0bae1ab6888bbe7dff",
    //     },
    //   ],
    //   missions: [
    //     {
    //       mission_id: 1,
    //       mission_title: "萌木の村ROCKでご飯の写真を1枚アップロード",
    //       mission_comment:
    //         "萌木の村ROCKでご飯の写真を1枚アップロード\r\n\r\n八ヶ岳といえば、萌木の村ROCKといわれるほど有名なお店です。\r\n地元の方からも人気で、連日行列を連ねるほど。\r\n\r\nここの名物カレーライスと、萌木の村特製のベーコンがもう絶品\r\n普段食べている格安ベーコンとはわけ違う（当たり前）\r\n是非ご賞味ください♬",
    //       mission_text:
    //         "萌木の村ROCKでご飯の写真を1枚アップロード\r\n\r\n八ヶ岳といえば、萌木の村ROCKといわれるほど有名なお店です。\r\n地元の方からも人気で、連日行列を連ねるほど。\r\n\r\nここの名物カレーライスと、萌木の村特製のベーコンがもう絶品\r\n普段食べている格安ベーコンとはわけ違う（当たり前）\r\n是非ご賞味ください♬",
    //       mission_image_url:
    //         "https://storage.googleapis.com/suisuitabi-server-flutter-dev-static/mission_images/Rock.jpg?X-Goog-Algorithm=GOOG4-RSA-SHA256&X-Goog-Credential=30721330066-compute%40developer.gserviceaccount.com%2F20230807%2Fauto%2Fstorage%2Fgoog4_request&X-Goog-Date=20230807T014150Z&X-Goog-Expires=86400&X-Goog-SignedHeaders=host&X-Goog-Signature=9954c7b2804535c683d8d868d616e143bdf63bc2ba1ff41f10de37e029f66702a647cb59d04cf41e24b06b871d1bc843529c30240f17c289a9675e5285cb846b86a9f2ea7da91ac715be99aa2bd781b7c1c02318c26f9e5c73e344113217664dbfa6c6a3676d3f6ea977c2f8b75727b6f0278ff446d79b089bdb8eac4efc8fb3f9c83f0e6a201de0bf747f877921c2e6419dee38720ad71e697d7cda32261aa26419f2b5c728ae13557fcbe60177389c11e02636c206f7bac28967917b7a143143567d8a2d54c80f261a73102ddf4200b284d17b60c2f29b9403b183c559f6ca63f14d97293d5fe760a204106d29c51b5cef275f02de6e7382ec0c8f00d5dd0e",
    //       mission_type: 20,
    //       quiz_items: [],
    //       mission_point: 50,
    //       spot: 3,
    //       created_at: "2022-07-31T16:26:46.405578+09:00",
    //       updated_at: "2023-03-10T13:28:30.207486+09:00",
    //     },
    //     {
    //       mission_id: 2,
    //       mission_title: "現在の萌木の村 ROCKについてのクイズに答えよう！",
    //       mission_comment:
    //         "現在の萌木の村 ROCKについてのクイズを出題します！\r\n全問正解して、ポイントをもらおう！",
    //       mission_text:
    //         "現在の萌木の村 ROCKについてのクイズを出題します！\r\n全問正解して、ポイントをもらおう！",
    //       mission_image_url:
    //         "https://storage.googleapis.com/suisuitabi-server-flutter-dev-static/mission_images/PXL_20210628_062321372.jpg?X-Goog-Algorithm=GOOG4-RSA-SHA256&X-Goog-Credential=30721330066-compute%40developer.gserviceaccount.com%2F20230807%2Fauto%2Fstorage%2Fgoog4_request&X-Goog-Date=20230807T014150Z&X-Goog-Expires=86400&X-Goog-SignedHeaders=host&X-Goog-Signature=7c956160fb2d2b02504bcd24525f74f9013c7a1043e32b037277a850ce5afb0642f1edecc79f64482cfdb5272c2aea55bb81f32f0b074c7262c14707ecbcc67859b2a1aef261ccba3bd46aa7f1efb7f56aabae6945845351cf35998875d8b8df8c3d58da522cf98d8408eb5fb69840ca73d6c89019f53cb047aa12b911dfa04f6e98398337b9b18ce84c411c8e39f6e29b399ee75d035ef5b6fb78417623e20b9f434f06136e79eedd351eec8419371cc65efbfb7919f17bc41b32cb17d94eb761c333d4015cac086dbb2292832e9e602ea46ae3b15aeac1c76acc40a7aaaa68187ef682602e2f8b3923dc232e046baf6639709dee00b9b051bf1c66d12fab26",
    //       mission_type: 30,
    //       quiz_items: [
    //         {
    //           id: 2,
    //           text: "現在の萌木の村 ROCKの建物は何回か建て替えています。\r\n現在の建物は、何代目でしょう？",
    //           quiz_options: [
    //             { text: "1", correct: false },
    //             { text: "2", correct: false },
    //             { text: "3", correct: true },
    //             { text: "4", correct: false },
    //           ],
    //           hint: "パンフレットを見ましょう",
    //           explanation: "3回です！！！",
    //           point: 2,
    //         },
    //         {
    //           id: 3,
    //           text: "萌木の村 ROCKの一番人気のメニューは何でしょう？",
    //           quiz_options: [
    //             { text: "カレー", correct: true },
    //             { text: "ビール", correct: false },
    //           ],
    //           hint: "",
    //           explanation: "",
    //           point: 1,
    //         },
    //       ],
    //       mission_point: 4,
    //       spot: 3,
    //       created_at: "2022-07-31T16:27:03.680389+09:00",
    //       updated_at: "2023-04-10T14:44:46.396500+09:00",
    //     },
    //   ],
    //   checkin: 0,
    //   docId: "oq8wg2U9fMoSpNqfv9r3",
    //   measure_spots: [],
    //   tickets: [
    //     {
    //       id: 6,
    //       number: 1,
    //       text: "入場料200円OFF",
    //       start_term: "2024-05-11T23:59:00+09:00",
    //       end_term: "2024-05-11T23:59:00+09:00",
    //     },
    //   ],
    // },
    mypage: undefined,
    jyutai: undefined,
  },
  selectedSpotCommentData: {
    dropspot: [],
    mypage: [],
    jyutai: [],
  },
  selectedSpotTicketData: {
    dropspot: [],
    mypage: [],
    jyutai: [],
  },
  selectedSpotDocId: undefined,
  shoModalAll: false,
  currentMap: undefined,
  selectedSpotType: {
    dropspot: undefined,
    jyutai: undefined,
  },
  dropDestionaton: {
    dropspot: undefined,
    mypage: undefined,
    jyutai: undefined,
  },
  lastRoute: {
    dropspot: undefined,
    mypage: undefined,
    jyutai: undefined,
  },
  miniLoading: false,
};



// WEBPACK FOOTER //
// ./src/store/state.js